
import { defineComponent, reactive, ref, UnwrapRef, watch } from 'vue'
import { useRoute } from 'vue-router'
import { ValidateErrorEntity } from 'ant-design-vue/es/form/interface'
import { notification } from 'ant-design-vue'

import validate from '../../../services/validator'
import profileService from '../../../services/profile'
import commonServices from '../../../services/common'

import IClient from '../../../interface/profile'

interface Users {
  first_name: string;
  lastName: string;
  email: string;
}

export default defineComponent({
  props: ['showUserModel', 'editUser'],
  setup (props, { emit }) {
    const visible = ref<boolean>(false)
    const userFormRef = ref()
    const userRules = validate.newUser
    const notify = async (message: string, description: string, type: string) => {
      notification[type]({ message, description })
    }
    const userForm: UnwrapRef<IClient> = reactive({
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      profile_image: '',
      client_name: '',
      client_logo: '',
      certificate_access: false,
      created_by: '',
      profile_type: '',
      is_active: true,
      status: 'paid',
      send_login: true,
      address: '',
      address_details: {}
    })
    const handleCancel = () => {
      console.log('Clicked cancel button')
      visible.value = false
    }
    const edituser = async (data) => {
      console.log('e', data)
    }
    const adduser = async (data) => {
      try {
        const clientId = commonServices.getClientId()
        const responce = await profileService.createNewUser(data, clientId)
        if (typeof responce.data === 'string') {
          await notify('Error', responce.data, 'error')
          return
        }
        emit('refreshUserList', responce)
        notify('Success', 'User added successfully', 'success')
        visible.value = false
      } catch (error) {
        console.log('error', error)
      }
    }
    const validateUserForm = () => {
      userFormRef.value
        .validate()
        .then(() => {
          if (props.editUser) {
            edituser(userForm)
          } else {
            adduser(userForm)
          }
        })
        .catch((error: ValidateErrorEntity<IClient>) => {
          console.log('error', error)
        })
    }
    watch(() => props.showUserModel, () => {
      visible.value = true
    })
    return {
      visible,
      userFormRef,
      userForm,
      handleCancel,
      validateUserForm,
      userRules,
      adduser,
      edituser
    }
  }
})
